import React from "react";

interface OwnProps {
}

interface OwnState {
}

export class WrapperLess extends React.Component<OwnProps, OwnState> {
    public render() {
        return this.props.children;
    }
}



// WEBPACK FOOTER //
// ./src/components/generic/WrapperLess.tsx